import { z, null as zNull } from "zod";

export const deleteParcel = {
  input: z.object({ name: z.string() }),
  output: zNull(),
};
